import BaseUser from './BaseUser';
import MemberRank from './MemberRank';

export enum CustomerType {
  PERSONAL = 'personal',
  BUSINESS = 'business',
}
export default interface Customer {
  id: string;
  baseUserId: string;
  baseUser?: BaseUser;
  type: CustomerType;
  description?: string;
  taxCode?: string;
  companyName?: string;
  companyPhone?: string;
  companyEmail?: string;
  companyAddress?: string;
  resName?: string;
  resPhone?: string;
  resEmail?: string;
  points: number;
  memberRankId?: string | null;
  memberRank?: MemberRank;
  warehouseId?: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  deletedAt?: Date | null;
}
export interface BaseUserCreate {
  name?: string;
  code?: string;
  email?: string;
  phoneNumber?: string;
  address?: string | null;
  avatarImage?: string;
  isActive?: boolean;
}

export interface CustomerCreate {
  type?: string; // hoặc: 'personal' | 'business' nếu bạn dùng enum CustomerType
  description?: string | null;
  taxCode?: string | null;
  companyName?: string | null;
  companyPhone?: string | null;
  companyEmail?: string | null;
  companyAddress?: string | null;
  resName?: string | null;
  resPhone?: string | null;
  resEmail?: string | null;
  points?: number | null;
  baseUser?: BaseUserCreate;
}
